
import common from './interface-list/common'

export default Object.assign(
  common,
)



// WEBPACK FOOTER //
// ./src/api/interface/index.js